import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import { companyQuery } from "#modules/company/infra/company.query";
import { deleteOnboardingProcessStepApi } from "#modules/onboardingV2/infra/deleteOnboardingProcessStep.api";
import {
  getOnboardingProcessStepsQueryData,
  onboardingProcessStepsQuery,
  setOnboardingProcessStepsQueryData,
} from "#modules/onboardingV2/infra/onboardingProcessSteps.query";

export const useDeleteOnboardingProcessStep = () => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: deleteOnboardingProcessStepApi,
    onMutate: async (variables) => {
      await queryClient.cancelQueries({ queryKey: onboardingProcessStepsQuery().queryKey });
      const previous = getOnboardingProcessStepsQueryData(queryClient);

      if (previous) {
        setOnboardingProcessStepsQueryData(
          queryClient,
          previous.filter((processStep) => processStep.id !== variables.id),
        );
      }

      return { previous };
    },
    onError: (err: Error, _variables, context) => {
      showErrorToast({ title: err.message });
      errorHandler(err);

      if (context?.previous) {
        setOnboardingProcessStepsQueryData(queryClient, context.previous);
      }
    },
    onSettled: () => {
      void queryClient.invalidateQueries(onboardingProcessStepsQuery());
      void queryClient.invalidateQueries(companyQuery());
    },
  });

  return { deleteOnboardingProcessStep: mutate, ...rest };
};
